<script>
    import { metaInfo } from "@/core/MetaInfo";
    import StoreContent from "@/components/store/StoreContent";

    export default {
        name: "Store",
        components: { StoreContent },
        computed: {
            sliderOptions() {
                return {
                    isScrollbar: true,
                    isBullets: true,
                    isArrow: true,
                    arrowPosition: "bottom",
                };
            },
        },
        metaInfo() {
            return metaInfo.getMeta("store");
        },
    };
</script>

<template>
    <store-content
        catalog-button-text="Выбрать рюкзак"
        :slider-options="sliderOptions"
        :slides-count="{ msk: 4, spb: 4 }"
        icon="metro"
    >
        <template #subtitle>
            Мой ноутбук поместится в рюкзак?
            <span>Цвет правда такой, как на фото?</span> Приглашаем убедиться лично.
            <div>
                Все рюкзаки XD&nbsp;Design можно примерить в магазинах Madrobots. Консультанты
                помогут определиться с моделью.
            </div>
        </template>
        <template #description-title>XD Design и Madrobots</template>
        <template #description-subtitle>
            <a href="https://madrobots.ru/" target="_blank">Madrobots.ru</a> — оператор
            официального интернет-магазина XD Design в России
        </template>
        <template #description-text>
            <span>Приходите в&nbsp;гости! Покажем, расскажем, подберем рюкзак мечты.</span>
            Понравилось несколько моделей? Добавьте в&nbsp;заказ все, примерьте
            в&nbsp;магазине&nbsp;&mdash; и&nbsp;возьмите самые подходящие.
        </template>
    </store-content>
</template>

<style lang="scss">
    .store-description {
        padding-bottom: 140px;
    }
    .store-description__button {
        bottom: -180px;
    }
</style>
